export class IdName<T = number> {
  public static get unspecified(): IdName {
    return new IdName(null, 'Unspecified');
  }

  public static get none(): IdName {
    return new IdName(null, 'None');
  }

  public static get allGenders(): IdName {
    return new IdName(null, 'All Genders');
  }

  public static get allRaces(): IdName {
    return new IdName(null, 'All Races');
  }

  public static get all(): IdName {
    return new IdName(undefined, 'All');
  }

  public static get programDuration(): IdName {
    return new IdName(null, 'Program duration');
  }

  public static get allWithNull(): IdName {
    return new IdName(null, 'All');
  }

  constructor(public id: T, public name: string) {}
}
